'use client';

import { c as _c } from "react/compiler-runtime";
import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.tsx';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import type { IconNames } from '@sola/schema/lib/icons/icon-names.ts';
import type { AssetLink } from '@sola/schema/lib/schema.ts';
import { trackFileDownload } from '@sola/tracking/lib/analytics/events.ts';
const downloadableExtensions = /\.(pdf|doc|docx|xls|xlsx|ppt|pptx|zip|csv|png|jpg|jpeg|gif|svg|mp4|mp3|wav)$/i;
const getFileName = (url: string): string | undefined => {
  try {
    const pathname = new URL(url).pathname;
    const segments = pathname.split('/');
    const last = segments.at(-1);
    return last || undefined;
  } catch {
    return undefined;
  }
};
const isDownloadableFile = (url: string): boolean => downloadableExtensions.test(url);
const getAssetHref = (asset: AssetLink): string => {
  switch (asset.linkType) {
    case 'internal':
      {
        return asset.entry.path ?? '';
      }
    case 'download':
      {
        return asset.download.path ?? '';
      }
    case 'external':
      {
        return asset.url;
      }
    default:
      {
        return (asset as {
          url?: string;
        }).url ?? '';
      }
  }
};
const getAssetKey = (asset: AssetLink, index: number): string => {
  switch (asset.linkType) {
    case 'internal':
      {
        return `internal-${asset.entry.id}-${index}`;
      }
    case 'download':
      {
        return `download-${asset.download.id}-${index}`;
      }
    case 'external':
      {
        return `external-${asset.url}-${index}`;
      }
    default:
      {
        return `asset-${index}`;
      }
  }
};
const buttonClassMap: Record<string, string> = {
  primary: 'btn btn--primary btn--sm',
  secondary: 'btn btn--secondary btn--sm',
  tertiary: 'btn btn--tertiary btn--sm'
};
type AssetLinksFooterProps = {
  assets: AssetLink[];
};
export const AssetLinksFooter = t0 => {
  const $ = _c(4);
  const {
    assets
  } = t0;
  let t1;
  if ($[0] !== assets) {
    t1 = assets.map(_temp);
    $[0] = assets;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="flex flex-wrap gap-comfy-sm">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
function _temp(asset, index) {
  const href = getAssetHref(asset);
  const buttonClass = buttonClassMap[asset.buttonType ?? "secondary"] ?? buttonClassMap.secondary;
  const sharedContent = <>{asset.icon && <ArkIcon iconName={asset.icon as IconNames} size="1em" style={{
      marginRight: "0.4em"
    }} />}{asset.label}</>;
  if (asset.linkType === "internal") {
    return <ButtonStyle variant={asset.buttonType} key={getAssetKey(asset, index)}><a key={getAssetKey(asset, index)} href={href} className={buttonClass}>{sharedContent}</a></ButtonStyle>;
  }
  if (asset.linkType === "download") {
    const downloadable = isDownloadableFile(href);
    const fileName = getFileName(href);
    return <ButtonStyle variant={asset.buttonType} key={getAssetKey(asset, index)}><a href={href} className={buttonClass} onClick={() => {
        trackFileDownload(asset.label, href);
      }} download={downloadable} title={fileName}>{sharedContent}</a></ButtonStyle>;
  }
  const downloadable_0 = isDownloadableFile(href);
  return <ButtonStyle variant={asset.buttonType} key={getAssetKey(asset, index)}><a href={href} rel="noopener noreferrer" onClick={() => {
      if (downloadable_0) {
        trackFileDownload(asset.label, href);
      }
    }} download={downloadable_0} title={getFileName(href)}>{sharedContent}</a></ButtonStyle>;
}